import { rankCol, playerCol, teamCol, divCol,teamNameCol, confCol, yearCol, numCol, round3Col, round1Col } from "./helpers";

const batterStats = [
  numCol("PA", "pa_overall"),
  round3Col("BA", "ba_overall"),
  round3Col("wOBA", "woba_overall"),
  numCol("PA RISP", "pa_risp", "6.5rem"),
  round3Col("BA RISP", "ba_risp", "6.5rem"),
  round3Col("wOBA RISP", "woba_risp", "7rem"),
  numCol("PA LI+", "pa_high_leverage", "6rem"),
  round3Col("BA LI+", "ba_high_leverage", "6.5rem"),
  round3Col("wOBA LI+", "woba_high_leverage", "7rem"),
  numCol("PA LI-", "pa_low_leverage", "6rem"),
  round3Col("BA LI-", "ba_low_leverage", "6.5rem"),
  round3Col("wOBA LI-", "woba_low_leverage", "7rem"),
  round1Col("RE24", "rea_overall"),
];

const pitcherStats = [
  numCol("BF", "pa_overall"),
  round3Col("o-BA", "ba_overall"),
  round3Col("o-wOBA", "woba_overall", "7rem"),
  numCol("BF RISP", "pa_risp", "6.5rem"),
  round3Col("o-BA RISP", "ba_risp", "7rem"),
  round3Col("o-wOBA RISP", "woba_risp", "7.5rem"),
  numCol("BF LI+", "pa_high_leverage", "6rem"),
  round3Col("o-BA LI+", "ba_high_leverage", "7rem"),
  round3Col("o-wOBA LI+", "woba_high_leverage", "7.5rem"),
  numCol("BF LI-", "pa_low_leverage", "6rem"),
  round3Col("o-BA LI-", "ba_low_leverage", "7rem"),
  round3Col("o-wOBA LI-", "woba_low_leverage", "7.5rem"),
  round1Col("RE24", "rea_overall"),
];

export const columnsSituationalBatter = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...batterStats,
];

export const columnsSituationalPitcher = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...pitcherStats,
];

export const columnsSituationalBattingTeam = [
  rankCol(), teamNameCol(), confCol(), divCol(), yearCol(),
  ...batterStats,
];

export const columnsSituationalPitchingTeam = [
  rankCol(), teamNameCol(), confCol(), divCol(), yearCol(),
  ...pitcherStats,
];
